<template>
  <v-container class="booking-detail p-0" v-if="record">
    <vue-headful :title="$t('package.detail_title')"></vue-headful>

    <HkiaraceBannerFrame :label="$t('package.detail_title')">
      <v-container class="booking-detail-content" fluid>
        <v-row>
          <v-col>
            <v-text-field :label="$t('package.create_at')"
                          readonly
                          hide-details
                          :value="$parseDate(record.create_at)"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field :label="$t('package.name')"
                          readonly
                          hide-details
                          :value="record.type.name"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field :label="$t('package.price')"
                          readonly
                          hide-details
                          prefix="HKD"
                          :value="record.price"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea :label="$t('package.content')"
                        readonly
                        hide-details
                        :value="packageContent"
                        rows="1"
                        auto-grow
                        no-resize></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-left">
            <v-btn color="primary"
                   :to="{name: 'my-account', query: {t: 7}}">
              {{ $t('back') }}
            </v-btn>
          </v-col>
        </v-row>

      </v-container>
    </HkiaraceBannerFrame>
  </v-container>
</template>

<script>
import {ref, onMounted, computed} from '@vue/composition-api';
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";

export default {
  name: 'PackageDetail',
  components: {HkiaraceBannerFrame},
  setup(props, {root}) {
    onMounted(() => {
      getItemTypes();
      getPackagePurchaseRecord();
    });

    const itemTypes = ref([]);
    const itemTypeNameMap = computed(() => {
      let map = {};

      itemTypes.value.forEach((t) => {
        map[t.id] = t.name;
      })

      return map;
    })
    const getItemTypes = function () {
      root.$callAPI('aafb/facility_types/', {}, function (response) {
        itemTypes.value = response.body.item_types;
      });
    }

    const record = ref(null);
    const getPackagePurchaseRecord = function () {
      root.$callAPI('aafb/package/', {
        package_id: root.$route.params.packageId
      }, (response) => {
        record.value = response.body.package;
      });
    };
    const packageContent = computed(() => {
      return JSON.parse(record.value.type.content).map((item) => {
        if (item.type === 'point') {
          return `${item.point} ${root.$t('my_account.points')}`;
        } else if (item.type === 'coupon') {
          return `${itemTypeNameMap.value[item.coupon.item_type_id]} ${root.$t('my_account.coupon')} - HKD ${item.coupon.amount} X ${item.coupon.count}`
        }
      }).join('\n');
    })

    return {
      record,
      packageContent,
    }
  },
}
</script>

<style lang="less">
.booking-detail {
  padding: 30px;

  .booking-detail-content {
    background-color: white;
    padding: 2rem;

    .v-label {
      color: #8E765B;
    }

    .v-text-field > .v-input__control > .v-input__slot:before {
      display: none;
    }

    .v-text-field > .v-input__control > .v-input__slot:after {
      display: none;
    }
  }

  .fa-chevron-circle-left {
    font-size: 5em;
    cursor: pointer;
  }

  .confirm-message-label {
    text-align: left;
    line-height: 2.5em;
    font-size: 2em;
  }

  .booking-summary-title {
    text-align: left;
    font-size: 2.5em;
  }

  .booking-preview-form {
    border: 1px solid rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 30px;
    font-size: 1.2em;

    .col-form-label {
      color: rgba(0, 0, 0, 0.5);
      text-align: left;
    }
  }

  .accept-tnc {
    text-align: left;
    padding: 30px;
    font-size: 1.2em;
  }
}

.countdown {
  text-align: right;
}
</style>
